import { ResourceCard } from '../types';
import { generateResourceCard } from '../utils/resource-card.util';
import { documentLinks, documentLinksStatic } from '../constants';

export const DOCUMENTS_MOCK_DATA: ResourceCard[] = generateResourceCard(
  documentLinks,
  { ...documentLinksStatic(true, 'resource-documents__') },
);
